import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-soggetto',
  templateUrl: './soggetto.component.html',
  styleUrls: ['./soggetto.component.css']
})
export class SoggettoComponent implements OnInit {
  callSoggetto={};
  
  constructor() { }

  ngOnInit() {
  }

  AllEvent(e:any){
    console.log(e.name);
    if(e.name=='onEditorPrepared'){
      e.cancel=true;
      this.callSoggetto={};
      this.callSoggetto['data']=e.data;
      this.callSoggetto['masterKey']='id'

    }
    //
  }
  optionalButtonSoggetto(e:any){

  }

}
